import { Container, Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
/* custom code start: no anontools, language selector or navigation in the
   header, the "Neu" button and the user details modal live here
   (#19259, #19371) */
import AddButton from '@horn-und-horn/volto-theme/components/theme/AddButton/AddButton';
import UserDetailsModal from '../../../../../components/theme/UserDetailsModal';
/* custom code end */

import Logo from '@plone/volto/components/theme/Logo/Logo';
import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';

/* custom code start: the burger button toggles our navbar (#19259) */
const Header = ({ pathname, navbarOpen, toggleNavbar }) => {
  return (
    <Segment basic className="header-wrapper" role="banner">
      <Container>
        <div className="header header-main">
          <button
            aria-label={`${navbarOpen ? 'Close' : 'Open'} navbar`}
            aria-expanded={navbarOpen}
            aria-controls="navbar"
            onClick={toggleNavbar}
          >
            <span role="none" />
            <span role="none" />
            <span role="none" />
          </button>
          <div className="logo-nav-wrapper">
            <div className="logo">
              <Logo />
            </div>
          </div>
          <div className="tools-search-wrapper">
            <div className="search">
              <SearchWidget />
            </div>
          </div>
          <div className="header-actions-wrapper">
            <div className="header-action add-content-menu-wrapper">
              <AddButton pathname={pathname} />
            </div>
          </div>
          <div className="break-column"></div>
        </div>
      </Container>

      <UserDetailsModal />
    </Segment>
  );
};
/* custom code end */

export default Header;

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
  /* custom code start */
  navbarOpen: PropTypes.bool.isRequired,
  toggleNavbar: PropTypes.func.isRequired,
  /* custom code end */
};

Header.defaultProps = {
  token: null,
  content: null,
};
